export default "__VITE_ASSET__CmF9zQAF__"